import { Component } from 'react';

import { RootState } from '@iwProvider/configureStore';
import { connect } from 'react-redux';

import styles from './ProcessingPaymentModal.module.css';
import { PaymentMethodAuthenticationModal } from '../paymentMethodAuthenticationModal/PaymentMethodAuthenticationModal';
import Failed from './Failed/Failed';
import BankLogo from './images/bank.svg';
import IwocaLogo from './images/red-iwoca-logo.svg';
import TruelayerLogo from './images/truelayer.svg';
import Loading from './Loading/Loading';
import { PaymentInitiated } from './PaymentInitiated';
import Success from './Success/Success';
import { TRUELAYER_REPAYMENT_TYPE } from '../../earlyRepayment/EarlyRepaymentHelper';
import { DRAW_DOWN_MODE } from '../../funding/ConfirmFundingView/ConfirmFunding.sagas';

const mapStateToProps = ({
    processingPaymentModal
}: {
    processingPaymentModal: RootState['processingPaymentModal'];
}) => ({
    ...processingPaymentModal
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

function getSenderAndReceiverLogo(
    mode: string | undefined,
    paymentMethod: string | null
) {
    if (mode === DRAW_DOWN_MODE) {
        return [IwocaLogo, BankLogo];
    }
    if (paymentMethod === TRUELAYER_REPAYMENT_TYPE) {
        return [IwocaLogo, TruelayerLogo];
    }
    return [BankLogo, IwocaLogo];
}

class ProcessingPaymentModal extends Component<PropsFromRedux> {
    renderContent() {
        const {
            paymentStatus,
            authenticationIframeURL,
            mode,
            paymentMethod,
            paymentInstructionId
        } = this.props;

        const [senderLogo, receiverLogo] = getSenderAndReceiverLogo(
            mode,
            paymentMethod
        );

        switch (paymentStatus) {
            case 'initiated':
                return (
                    <PaymentInitiated
                        paymentInstructionId={paymentInstructionId!}
                        senderLogo={senderLogo}
                        receiverLogo={receiverLogo}
                    />
                );
            case 'success':
                return (
                    <Success
                        senderLogo={senderLogo}
                        receiverLogo={receiverLogo}
                    />
                );
            case 'authentication_required':
                return (
                    <PaymentMethodAuthenticationModal
                        authenticationIframeURL={authenticationIframeURL!}
                    />
                );
            case 'failure':
                return (
                    <Failed
                        senderLogo={senderLogo}
                        receiverLogo={receiverLogo}
                    />
                );
            default:
                return (
                    <Loading
                        senderLogo={senderLogo}
                        receiverLogo={receiverLogo}
                    />
                );
        }
    }

    render() {
        return (
            <div className={styles.ProcessingPaymentModal}>
                <div className={styles.content}>{this.renderContent()}</div>
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(ProcessingPaymentModal);
